// eslint-disable-next-line import/no-extraneous-dependencies
import { RiCheckFill } from "@remixicon/react";
import classNames from "classnames";
import React, {
    ReactElement, ReactNode,
} from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import useMergedRefs from "@restart/hooks/useMergedRefs";
// eslint-disable-next-line import/no-extraneous-dependencies
import useWrappedRefWithWarning from "react-bootstrap/useWrappedRefWithWarning";
// eslint-disable-next-line import/no-extraneous-dependencies
import { CSS } from "@dnd-kit/utilities";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useSortable } from "@dnd-kit/sortable";
import Dropdown from "../dropdown/Dropdown";
import { ItemProps } from "../dropdown/Item";

export interface DraggableItemProps extends ItemProps {
    isActive?: boolean;
    className?: string;
    isChecked?: boolean;
    postFixItem?: ReactNode;
    prefixIcon?: ReactNode;
    id: string;
    children?: ReactNode
}

const DraggableItem = React.forwardRef((
    args: DraggableItemProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactElement => {
    const {
        isActive,
        className,
        id,
        ...rest
    } = args;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    const mergedRef = useMergedRefs(
        useWrappedRefWithWarning(ref, "DropdownItem"),
        setNodeRef,
    );

    return (
        <Dropdown.Item
            ref={mergedRef}
            className={classNames(className, { active: isActive })}
            style={style}
            // prefixIcon={prefixIcon}
            {...rest}
            {...listeners}
            {...attributes}
        />

    );
});

DraggableItem.defaultProps = {
    className: "",
    isActive: false,
    postFixItem: undefined,
    prefixIcon: undefined,
};

export default DraggableItem;
